
export const SportAPI = {};

const SLICE = 'sport';

SportAPI.create = (data, onSuccess, onFailure) => {
  return {
    type:     'API',
    url:      `/stream/sport`,
    method:   'POST',
    data:     data,
    slice:     SLICE,
    action:    'create',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

SportAPI.delete = (ids, onSuccess, onFailure) => {
  return {
    type:      'API',
    url:       `/stream/sport`,
    method:    'DELETE',
    data:      {ids},
    slice:     SLICE,
    action:    'delete',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

SportAPI.update = (data, onSuccess, onFailure) => {
  return {
    type:     'API',
    url:      `/stream/sport`,
    method:   'PUT',
    data:     data,
    slice:     SLICE,
    action:    'update',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

SportAPI.list = (data, onSuccess, onFailure) => {
  return {
    type:      'API',
    url:       `/stream/sports`,
    method:    'GET',
    data:      data,
    slice:     SLICE,
    action:    'list',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

SportAPI.item = (id, onSuccess, onFailure) => {
  return {
    type:      'API',
    url:       `/stream/sport`,
    method:    'GET',
    data:      {id},
    slice:     SLICE,
    action:    'item',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

SportAPI.import = (file, onSuccess, onFailure) => {
  return {
    type: 'API',
    url: `/stream/sports/import`,
    method: 'POST',
    data: file,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    slice: SLICE,
    action: 'import',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};